import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Podcast } from 'lucide-react';
import { PODCAST_EPISODES_QUERY, type EpisodeListItem } from '../shared/index.ts';
import { EpisodeRow, EpisodeListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/podcasts',        label: 'For You', end: true },
  { to: '/podcasts/latest', label: 'Latest' },
  { to: '/podcasts/shows',  label: 'Shows' },
  { to: '/podcasts/seen',   label: 'Heard' },
  { to: '/podcasts/saved',  label: 'Saved' },
];

export function Podcasts() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['podcasts', 'list'],
    queryFn: async () => {
      const res = await gql.request<{ podcastEpisodes: EpisodeListItem[] }>(PODCAST_EPISODES_QUERY);
      return res.podcastEpisodes;
    },
    refetchInterval: 60_000,
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="Podcasts" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <EpisodeListSkeleton />
        ) : error ? (
          <ErrorRetry label="Could not load podcasts." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Podcast size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No episode summaries yet — the transcriber is warming up.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((ep) => <EpisodeRow key={ep.id} ep={ep} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
